{
  "manager": {
    "feeIndex": {
      "pageTitle": "Fees"
    }
  }
}
